export default "__VITE_ASSET__C90$AOyp__"